/** Serialize a shipment's reads and writes so older mutation responses cannot replace newer state. */
export function queuedIncomingApi(api) {
  let tail = Promise.resolve();
  return Object.fromEntries(
    Object.entries(api).map(([name, request]) => [
      name,
      (...args) => {
        const result = tail.then(() => request(...args));
        tail = result.then(
          () => undefined,
          () => undefined,
        );
        return result;
      },
    ]),
  );
}
